let productsList;
let filterProducts = [];
let input, keyword, container, filterContainer, recipeProducts, text;
let maxItemsDisplay = 12;
let itemsShowed = 12;
let white = "#FFFFFF";
let midnightGreenEagle = "#005157";
var recipes;
var selectedRecipes;
var filteredRecipes;
var button_load;
let ocassions = [];
let ocassionsId = 0;
var itemSelected = [];
var filterActive = false;
if(document.getElementById("simple-header__recipe__title") != null && document.getElementById("simple-header__recipe__subtitle") != null) {
    var titleHeader = document.getElementById("simple-header__recipe__title").innerHTML;
    var subtitleHeader = document.getElementById("simple-header__recipe__subtitle").innerHTML;
    var subtitleAvailable = true;
}
else {
    var subtitleAvailable = false;
}

function loadInput() {
    text = localStorage.getItem('input');
    if (text !== '' && text !== 'undefined' && text !== null ) {
        document.getElementById('recipeSearch').value = text;
        returnFilterProducts();
    } else {
        document.getElementById('recipeSearch').value = null;
    }
    localStorage.removeItem("input");
}

function showImage (element) {
    const src = element.getAttribute('src');
    const hiddenSrc = element.getAttribute('data-src');
    const hiddenSrcset = element.getAttribute('data-srcset');
    if (hiddenSrc && !src) {
        element.setAttribute('src', hiddenSrc);
        element.setAttribute('srcset', hiddenSrcset);
    }
}

function showImages(parentElement) {
    const images = parentElement.getElementsByTagName('img');
    for (let img_x = 0; img_x < images.length; img_x++) {
        const element = images[img_x];
        showImage(element);
    }
}

function getRecipes() {
    changeRecipesQuantityShowed();
    productsList = [...recipes];
    productsList = productsList.filter((value, index, self) =>
        index === self.findIndex((t) => (
            t.getAttribute('productid') === value.getAttribute('productid')
        ))
    )
    recipeProducts = document.getElementById('recipe-products');
    recipes.forEach((element, index) => {
        if(index < itemsShowed) {
            element.style.display = "block";
            showImages(element);
        }
        else {
            element.style.display = "none";
        }
    });
}

function loadMore() {
    itemsShowed += maxItemsDisplay;
    var recipesShowed = 0;
    if(selectedRecipes.length != 0) {
        recipes.forEach(recipe => {
            recipe.style.display = "none";
        });
        selectedRecipes.forEach(recipe => {
            if(recipesShowed < itemsShowed) {
                recipe.style.display = "block";
                showImages(recipe);
                recipesShowed++;
            }
        });
        if(selectedRecipes.length < itemsShowed) {
            button_load.style.display = "none";
        }
    }
    else {
        recipes.forEach(recipe => {
            if(recipesShowed < itemsShowed) {
                recipe.style.display = "block";
                showImages(recipe);
                recipesShowed++;
            }
            else {
                recipe.style.display = "none";
            }
        });
        if(recipes.length < itemsShowed) {
            button_load.style.display = "none";
        }
    }
}

function filteredProducts() {
    input = document.getElementById('recipeSearch').value;
    keyword = input.toLowerCase();
    if ( keyword !== "" && productsList.length > 0 ) {
        // using split function to separate the hover button text from the title
        filterProducts = productsList.filter(recipe => recipe.getAttribute("productname").toString().toLowerCase().includes(keyword));        
    }
    else {
        filterRecipesContent();
    }
}

function returnFilterProducts() { 
    filteredProducts();
    if (keyword === "") {
        resetFiltered();
        container = document.getElementById('recipe-products-list');
        container.innerHTML = "";
        filterContainer = document.getElementById('recipe-products-list-filter');
        filterContainer.innerHTML = "";
        filteredRecipes.style.display = 'none';
        recipeProducts.style.display = 'flex';
        productsList.forEach(element => {
            container.innerHTML += element.outerHTML;
        });
    } else { 
        filteredRecipes.style.display = 'flex';
        recipeProducts.style.display = 'none';
        filterContainer = document.getElementById('recipe-products-list-filter');
        filterContainer.innerHTML = "";
        container = document.getElementById('recipe-products-list');
        container.innerHTML = "";
        filterProducts.forEach(element => {
            filterContainer.innerHTML += element.outerHTML;
        });
    }
    const sortField = document.getElementById("recipe-info");
    sortBy(sortField);
    filterRecipesContent();
    restoreLoadMore();
}

function resetFiltered() {
    filterProducts = [];
}

function chargeRecipes() {
    var enter = document.getElementById('recipeSearch');
    enter.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
            returnFilterProducts();
        }
    });
}

function searchRecipe() {
    returnFilterProducts();
}

function changeRecipesQuantityShowed() {
    let width = window.innerWidth;
    if (width > 460 && width < 750){
        maxItemsDisplay = 10;
    }
    else if (width < 460) {
        maxItemsDisplay = 5;
    }
    else {
        maxItemsDisplay = 12;
    }
    restoreLoadMore();
}

function counter(ocassion, recipeTitle) {
    if (ocassion !== "") {
        if(ocassions.length == 0) {
            ocassions.push({title: ocassion, count: 1, recipeName: recipeTitle, recipeId: ocassionsId});
        }
        else {
            var recipeRepeated = false;
            ocassions.forEach(element => {
                if(element.title == ocassion && element.recipeName == recipeTitle){
                    recipeRepeated = true;
                }
            });
            if(!recipeRepeated) {
                ocassions.push({title: ocassion, count: 1, recipeName: recipeTitle, recipeId: ocassionsId});
            }
        }
        ocassionsId++;
    }
}

function chargeMetafields(id) {
    ocassions = ocassions.filter((ocassions, index, self) => index === self.findIndex((t) => (t.title === ocassions.title)));
    ocassions.forEach(element => {
        var div1 = document.createElement('div');
        div1.setAttribute('class', 'option-container');
        div1.setAttribute('form-id', element.title.replace(/\s/g, ""));

        var div2 = document.createElement('div');
        div2.setAttribute('class', 'option-label-container');

        var div3 = document.createElement('div');
        div3.setAttribute('class', 'option-checkbox');

        var input = document.createElement('input');
        input.setAttribute('id', 'checkbox');
        input.setAttribute('type', 'checkbox');
        input.setAttribute('topic', id);
        input.setAttribute('recipetype', element.title.replace(/\s/g, ""));
        input.setAttribute('recipename', element.title);
        input.setAttribute('id', element.title.replace(/\s/g, ""));
        input.setAttribute('class', 'input-checkbox');
        input.setAttribute('onclick', 'filterByCollection(this);');

        var label = document.createElement('div');
        label.setAttribute('id', element.title);
        label.setAttribute('for', 'checkbox');
        label.setAttribute('class', 'option-label');
        label.innerHTML = "<span></span>";
        label.firstChild.textContent = element.title;

        var labelCheckbox = document.createElement('label');
        labelCheckbox.setAttribute('for', 'checkbox');
        labelCheckbox.setAttribute('class', 'checkbox');
        labelCheckbox.innerHTML = "<svg class='icon icon-tick' aria-hidden='true' focusable='false' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'><path fill='#108043' stroke='#fff' d='M16.136 6.979h0l.003-.004a1.499 1.499 0 00-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 103.94 12.06l2.999 3s0 0 0 0c.289.29.675.44 1.1.439h.019a1.5 1.5 0 001.08-.522l6.998-7.998z'/></svg>"

        var quantity = document.createElement('label');
        quantity.setAttribute('class', 'option-quantity');
        quantity.textContent = '(' + element.count + ')';

        div3.appendChild(labelCheckbox);
        div3.appendChild(input);
        div3.appendChild(label);

        div2.appendChild(div3);

        div1.appendChild(div2);
        div1.appendChild(quantity);

        var container = document.getElementById(id + '-container');
        container.appendChild(div1);
    });
}

function countItems() {
    var input = document.getElementsByClassName('option-container');
    input.forEach(element => {
        var quantity = 0;
        recipes.forEach(recipe => {
            if(recipe.classList.contains(element.getAttribute("form-id"))){
                quantity++;
            }
        });
        element.childNodes[1].innerHTML = "(" + quantity + ")";
    });
}
    
function setRecipesQuantity() {
    var counter = 0;
    const itemsDisplayed = document.getElementsByClassName('recipeSelected');
    const recipesList = document.getElementById('recipe-products-list');
    const filteredRecipesList = document.getElementById('recipe-products-list-filter');
    if(itemsDisplayed.length != 0) {
        counter = itemsDisplayed.length;
    }
    else if(recipesList.clientHeight == 0 && filteredRecipesList.clientHeight == 0){
        counter = 0;
    }
    else {
        recipes.forEach(() => {
            counter++;
        });   
    }
    var quantity = document.getElementById('recipe-quantity');
    quantity.children[0].innerHTML = counter + " recipes";
}

function reset() {
    ocassions = [];
}

function arrayRemove(arr, value) { 
    return arr.filter(function(ele){ 
        return ele.id != value; 
    });
}

function filterByCollection(input) {
    var id = input.getAttribute("recipetype");
    var name = input.getAttribute("recipename");
    var checkbox = document.getElementById(id).previousElementSibling;
    if(itemSelected.some(item => item.id === id)) {
        checkbox.style.backgroundColor = white;
        itemSelected = arrayRemove(itemSelected, id);
        uncheckItemAndDeleteDiv(id);
    }
    else if(itemSelected.some(item => item.topic === input.getAttribute('topic') )) {
        itemSelected.forEach(element => {
            topicRepeated = document.getElementById(element.id);
            if(input.getAttribute('topic') == topicRepeated.getAttribute('topic')){
                topicRepeated.previousElementSibling.style.backgroundColor = white;
                itemSelected = arrayRemove(itemSelected, element.id);
                uncheckItemAndDeleteDiv(element.id);
            }
        })
        checkbox.style.backgroundColor = midnightGreenEagle;
        itemSelected.push({id: id, title: name, topic: input.getAttribute('topic') });
        createDeleteFilter(id, name);
    }
    else {
        checkbox.style.backgroundColor = midnightGreenEagle;
        itemSelected.push({id: id, title: name, topic: input.getAttribute('topic') });
        createDeleteFilter(id, name);
    } 
    changeSubtitleName(input);
    filterRecipesContent();
    setRecipesQuantity();
    resetClearAll();
    restoreLoadMore();
}

function resetClearAll() {
    var deleteItems = document.getElementById('filter-recipes-delete');
    var clearButton = document.getElementById('filter-recipes-clear');
    var clearButtonMobile = document.getElementById('filter-recipes-clear-mobile');
    var filterBox = document.getElementById('filter-recipes-topics-container');
    if (deleteItems.childNodes.length == 0) {
        clearButton.style.display = "none";
        let width = window.innerWidth;
        if (width <= 880){
            clearButtonMobile.style.display = "none";
        }
        filterBox.style.marginTop = "-100px";
    }
    else {
        clearButton.style.display = "block";
        let width = window.innerWidth;
        if (width <= 880){
            clearButtonMobile.style.display = "block";
        }
        filterBox.style.marginTop = "0px";
    }
}

function filterRecipesContent() {
    var deleteContainers = document.getElementsByClassName('delete-recipe-container');
    if(deleteContainers.length == 0){
        filterActive = false;
    }
    else {
        filterActive = true;
    }
    var deleteItems = document.getElementById('filter-recipes-delete');
    var deleteItemsMobile = document.getElementById('filter-recipes-delete-mobile');
    resetClearAll();
    if(itemSelected.length > 0){
        Array.from(recipes).forEach(element => {
            hiddeIfCollectionNotSelected(element);
        });
        let width = window.innerWidth;
        if(width > 880){
            deleteItems.style.display = 'block';
            deleteItems.style.marginTop = '-100px';
            deleteItemsMobile.style.display = 'none';
            deleteItemsMobile.style.marginTop = '-100px';
        }
        else {
            deleteItems.style.display = 'flex';
            deleteItems.style.marginTop = '-50px';
            deleteItemsMobile.style.display = 'flex';
            deleteItemsMobile.style.marginTop = '0px';
            
        }
    }
    else {
        Array.from(recipes).forEach(element => {
            showAll(element);
        });
        deleteItems.style.display = 'none';
        deleteItems.style.marginTop = '0';
        deleteItemsMobile.style.display = 'none';
        deleteItemsMobile.style.marginTop = '0';
    }
    setRecipesQuantity();
    restoreLoadMore();
}

function uncheckItemAndDeleteDiv(id) {
    var deleteButton = document.getElementById('delete-'+id);
    deleteButton.outerHTML = '';
    deleteButton = document.getElementById('delete-mobile-'+id);
    deleteButton.outerHTML = '';
    var input = document.getElementById(id);
    input.checked = false;
}

function deleteAllItemsSelected() {
    var deleteItems = document.getElementById('filter-recipes-delete');
    var deleteItemsMobile = document.getElementById('filter-recipes-delete-mobile');
    itemSelected.forEach(element => {
        uncheckItemAndDeleteDiv(element.id);
    });
    itemSelected = [];
    Array.from(recipes).forEach(element => {
        showAll(element);
    });
    var checkboxes = document.getElementsByClassName('checkbox');
    Array.from(checkboxes).forEach(element => {
        element.style.backgroundColor = "#FFFFFF";
    });
    deleteItems.style.display = 'none';
    deleteItems.style.marginTop = '0';
    deleteItemsMobile.style.display = 'none';
    deleteItemsMobile.style.marginTop = '0';
    setRecipesQuantity();
    restoreLoadMore();
    resetClearAll();
    changeSubtitleName(null);
}

function createDeleteFilter(id, name) {
    var container = document.getElementById('filter-recipes-delete');
    var deleteItemsMobile = document.getElementById('filter-recipes-delete-mobile');

    var div1 = document.createElement('div');
        div1.setAttribute('id', 'delete-'+id);
        div1.setAttribute('class', 'delete-recipe-container');

    var label = document.createElement('label');
        label.setAttribute('class', 'recipe-delete-title');
        label.textContent = name;
    
    div1.innerHTML = label.outerHTML;

    var div2 = document.createElement('div');
        div2.setAttribute('recipename', name);
        div2.setAttribute('recipetype', id);
        div2.setAttribute('class', 'recipe-delete-button');
        div2.innerHTML = '<p>X</p>'
        div2.setAttribute('onclick', 'filterByCollection(this);');

    div1.innerHTML += div2.outerHTML;

    container.innerHTML += div1.outerHTML;
    div1.setAttribute('id', 'delete-mobile-'+id);
    deleteItemsMobile.innerHTML += div1.outerHTML;

}

function hiddeIfCollectionNotSelected(item) {
    item.style.display = "none";
    var display = true;
    Array.from(itemSelected).forEach(selected => {
        if(!item.classList.contains(selected.id)){
            display = false;
        }
        else {
            if(selected.topic == "ocassions"){
                item.setAttribute('occassionselected', selected.title);
            }
            else if((selected.topic == "dish-type")) {
                item.setAttribute('dishtypeselected', selected.title);
            }
            else {
                item.setAttribute('productselected', selected.title);
            }
        }
    });
    if(display){
        item.classList.add("recipeSelected");
        item.style.display = "block";
        showImages(item);
    }
    else {
        if(item.classList.contains("recipeSelected")){
            item.classList.remove("recipeSelected");
        }
    }
}

function showAll(item) {
    item.style.display = "block";
    showImages(item);
    item.classList.remove("recipeSelected");
    filterActive = false;
}

function sortByLoader(select) {
  if(select.selectedIndex != null){
        var value = select.options[select.selectedIndex].value; 
    if (value != '' ) {
      document.getElementById('loader').style.display = 'block';
      var button = document.getElementsByClassName('ms-parent ');
      var element = [...button]
      element[0].style.display = 'none';
    }
    setTimeout(() => {sortBy(select);}, 200)
  }

}

function sortBy(select) {
    var itemsSorted = [];

    if(select.selectedIndex != null){
        var value = select.options[select.selectedIndex].value; 

        productsList.forEach((recipe) => {
            itemsSorted.push(recipe);
        });

        if(value == "asc"){
            itemsSorted.sort((a,b) => {
                var item1 = a.getAttribute('productname').toLowerCase().split(' ');
                var item2 = b.getAttribute('productname').toLowerCase().split(' ');
                var item1Length = item1.length;
                var item2Length = item2.length;
                if(item1Length > item2Length) {
                    for(var i=0; item1Length; i++){
                        if(item2[i] != null){
                            if(item1[i] != item2[i]) {
                                return (item1[i] > item2[i]) ? 1 : ((item1[i] < item2[i]) ? -1 : 0);
                            }
                        }
                        else {
                            return -1;
                        }
                    }
                }
                else if(item1Length < item2Length) {
                    for(var i=0; item2Length; i++){
                        if(item1[i] != null){
                            if(item1[i] != item2[i]) {
                                return (item1[i] > item2[i]) ? 1 : ((item1[i] < item2[i]) ? -1 : 0);
                            }
                        }
                        else {
                            return 1;
                        }
                    }
                }
                else {
                    for(var i=0; item1Length; i++){
                        if(item1[i] != item2[i]) {
                            return (item1[i] > item2[i]) ? 1 : ((item1[i] < item2[i]) ? -1 : 0);
                        }
                        else {
                            return 1;
                        }
                    }
                }
            });
        }
        if(value == "desc"){    
            itemsSorted.sort((a,b) => {
                var item1 = a.getAttribute('productname').toLowerCase().split(' ');
                var item2 = b.getAttribute('productname').toLowerCase().split(' ');
                var item1Length = item1.length;
                var item2Length = item2.length;
                if(item1Length > item2Length) {
                    for(var i=0; item1Length; i++){
                        if(item2[i] != null){
                            if(item1[i] != item2[i]) {
                                return (item1[i] > item2[i]) ? -1 : ((item1[i] < item2[i]) ? 1 : 0);
                            }
                        }
                        else {
                            return 1;
                        }
                    }
                }
                else if(item1Length < item2Length) {
                    for(var i=0; item2Length; i++){
                        if(item1[i] != null){
                            if(item1[i] != item2[i]) {
                                return (item1[i] > item2[i]) ? -1 : ((item1[i] < item2[i]) ? 1 : 0);
                            }
                        }
                        else {
                            return -1;
                        }
                    }
                }
                else {
                    for(var i=0; item1Length; i++){
                        if(item1[i] != item2[i]) {
                            return (item1[i] > item2[i]) ? -1 : ((item1[i] < item2[i]) ? 1 : 0);
                        }
                        else {
                            return -1;
                        }
                    }
                }
            });
        }
        if(value == "new"){
            itemsSorted.sort((a,b) => (a.getAttribute('productdate') > b.getAttribute('productdate')) ? -1 : ((b.getAttribute('productdate') > a.getAttribute('productdate')) ? 1 : 0));
        }
        if(value == "last"){
            itemsSorted.sort((a,b) => (a.getAttribute('productdate') > b.getAttribute('productdate')) ? 1 : ((b.getAttribute('productdate') > a.getAttribute('productdate')) ? -1 : 0));
        }

        var html = "";
        itemsSorted.forEach((recipe) => {
            recipe.style.display = 'block';
            showImages(recipe);
            html += recipe.outerHTML;
        });
        productsList = itemsSorted;
        container = document.getElementById('recipe-products-list');
        filterContainer = document.getElementById('recipe-products-list-filter');
        container.append(...filterProducts);
        filterContainer.append(...filterProducts);
        returnFilterProducts();
        document.getElementById('loader').style.display = 'none';
        var button = document.getElementsByClassName('ms-parent ');
        var element = [...button]
        element[0].style.display = 'block';
        showImages(element[0]);
    }
    restoreLoadMore(); 
    setRecipesQuantity();
}

function restoreLoadMore() {
    const recipesList = document.getElementById('recipe-products-list');
    const filteredRecipesList = document.getElementById('recipe-products-list-filter');
    button_load.style.display = "flex";
    itemsShowed = maxItemsDisplay;
    var recipesShowed = 0;
    if(selectedRecipes.length != 0) {
        recipes.forEach(recipe => {
            recipe.style.display = "none";
        });
        selectedRecipes.forEach(recipe => {
            if(recipesShowed < maxItemsDisplay) {
                recipe.style.display = "block";
                showImages(recipe);
                recipesShowed++;
            }
        });
        if(selectedRecipes.length < itemsShowed) {
            button_load.style.display = "none";
        }
    }
    else if(recipesList.clientHeight == 0 && filteredRecipesList.clientHeight == 0){
        button_load.style.display = "none";
    }
    else {
        recipes.forEach(recipe => {
            if(recipesShowed < maxItemsDisplay) {
                recipe.style.display = "block";
                showImages(recipe);
                recipesShowed++;
            }
            else {
                recipe.style.display = "none";
            }
        });
        if(recipes.length < itemsShowed) {
            button_load.style.display = "none";
        }
    }
}

function showFilterModal() {
    var modal = document.getElementById("filter-recipes");
    var modalIsDisplaying = modal.classList.contains('slidein');
    if (modalIsDisplaying) {
        modal.classList.add('slideout');
        modal.classList.remove('slidein');
    }
    else {
        modal.classList.remove('slideout');
        modal.classList.add('slidein');
    }

}

function hiddeFilters(section){
    var content = section.nextElementSibling;
    var sectionIsDisplaying = content.style.display === 'block' ? true : false;
    if (sectionIsDisplaying) {
        content.style.display = "none";
        section.children[1].style.transform = "rotate(270deg)";
    }
    else {
        content.style.display = "block";
        section.children[1].style.transform = "rotate(90deg)";
    }
}

function saveTags(item) {
    localStorage.setItem('occassionSelected', item.getAttribute('occassionselected'));
    localStorage.setItem('dishtypeSelected', item.getAttribute('dishtypeselected'));
    localStorage.setItem('productselected', item.getAttribute('productselected'));
}

function deleteEmptyFilters() {
    var emptyTopics = document.getElementsByClassName("topic-container-is-empty");
    emptyTopics.forEach((element) => {
        element.previousElementSibling.outerHTML = "";
    });
    var Topics = document.getElementsByClassName("topic-line");
    Topics[Topics.length - 1].style.border = "none";
}

function getPathVariable()
{
    var category =  window.location.pathname.substring(1) + window.location.search;
    category = category.split('collections/recipes?category=');
    var collection =  document.getElementById(category[1]);
    if(collection != null){
        filterByCollection(collection);
    }
    changeSubtitleName(collection);
}

function changeSubtitleName(collection) {
    if(subtitleAvailable) {
        var subtitle = document.getElementById("simple-header__recipe__subtitle");
        var title = document.getElementById("simple-header__recipe__title");
        var deleteItems = document.getElementById("filter-recipes-delete");
        if(subtitle != null){
            if (deleteItems.childNodes.length == 0 || collection == null){
                title.innerHTML = titleHeader;
                subtitle.innerHTML = subtitleHeader;
            }
            else {
                title.innerHTML = "RECIPES"
                subtitle.innerHTML = "";
                deleteItems.childNodes.forEach(element => {
                    if(subtitle.innerHTML == ""){
                        subtitle.innerHTML = element.childNodes[0].innerHTML;
                    }
                    else {
                        subtitle.innerHTML = subtitle.innerHTML + "<br>" + element.childNodes[0].innerHTML;
                    }
                });
            }
        }
    }
}

function loadInformation () {
  getRecipes();
  returnFilterProducts();
  countItems();
}

$(document).ready(function() {
    window.addEventListener("load", loadInformation)
    recipes = document.getElementsByClassName('recipe-products-item');
    selectedRecipes = document.getElementsByClassName('recipeSelected');
    button_load = document.getElementById('recipe-products-load-more-button');
    filteredRecipes = document.getElementById('recipe-products-filter');
    window.addEventListener('load', loadInput);
});